import {
	Entity,
	IntegerEntityAttribute,
	StringEntityAttribute
} from '../base/Entity';
import {slugify} from '../util/slugify';
import {oldApi} from '../../client/src/app/oldApi';

/**
 * @name Series
 * @property {Number} Id
 * @property {String} Name
 */
export class Series extends Entity {

	getRoute() {
		return {
			name: 'series',
			params: {
				seriesId: this.Id,
				seriesName: slugify(this.Name.toLowerCase())
			}
		}
	}

	getLogoUrl() {
		return oldApi.getDynamicFolderUrl({
			url: `series/${this.Id}_logo`
		});
	}

	getHeroUrl() {
		return oldApi.getDynamicFolderUrl({
			url: `series/${this.Id}_hero`
		});
	}
}

Series.Register('Series');
Series.Attributes = [
	new IntegerEntityAttribute('Id'),
	new StringEntityAttribute('Name'),
	new IntegerEntityAttribute('Order'),
	new StringEntityAttribute('ThumbUrl'),
];

export default Series;
